// src/components/ui/BackToTop.js
import React from 'react';
import { ArrowUp } from 'lucide-react';

/**
 * Botón flotante para volver al inicio.
 *
 * Estaba roto en dos frentes: App.js le pasa `onClick`, pero el componente
 * esperaba `scrollToTop`, así que el click no hacía nada; y como tampoco
 * recibía `showBackToTop`, se renderizaba con las clases `opacity-0 invisible`
 * y encima era invisible. Quien decide si mostrarlo es App.js, que ya lo
 * envuelve en una condición, así que acá no hace falta ninguna de las dos.
 *
 * En móvil importa más que en desktop: las páginas de ofertas son largas y
 * volver arriba a mano son varios swipes.
 */
export const BackToTop = ({ onClick }) => (
  <button
    id="ui-back-to-top"
    onClick={onClick}
    aria-label="Volver arriba"
    title="Volver arriba"
    className="safe-bottom boton-volver-arriba"
  >
    <ArrowUp size={22} />
  </button>
);
